import styled from 'styled-components/macro';
import { ReactComponent as Step1Img } from './Step1.svg';
import { ReactComponent as Step2Img } from './Step2.svg';
import { ReactComponent as Step3Img } from './Step3.svg';
import { ReactComponent as newPlateIcon } from './newPlate.svg';

export const Screen = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1000;
  min-width: 100%;
  min-height: 100%;
`;

export const WhiteScreen = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(252, 252, 252, 0.8);
  pointer-events: none;
`;

export const Step1 = styled(Step1Img)`
  position: relative;
`;

export const Step2 = styled(Step2Img)`
  position: relative;
`;

export const Step3 = styled(Step3Img)`
  position: relative;
`;

export const Scroll = styled.div`
  overflow: scroll;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Content = styled.div`
  position: relative;
`;

export const ContentMainScreen = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 452px;
  margin: 20px 22px 0;
`;

export const PlateMainScreen = styled.div`
  position: relative;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  padding: 12px 20px;
  width: 100%;
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  color: #ffffff;
`;

export const NewPlate = styled(newPlateIcon)`
  position: absolute;
  top: -13px;
  left: -13px;
`;
